const SERVER = "https://alhikmahinternational.org/al-asab/public"

export default {
    LOGIN: SERVER + "/api/login",
    FORGETPASSWORD: SERVER + "/api/forgot/password",
    OTP: SERVER + "/api/confirm/otp",
    CHANGEPASSWORD: SERVER + "/api/change-password",
    RESETPASSWORD: SERVER + "/api/reset/passsword",
    LOGOUT: SERVER + "/api/logout",
    PROJECTS: SERVER + "/api/projects",
    getRequests: SERVER + "/api/IMR/requests",
    getISRRequests: SERVER + "/api/ISR/requests",
    ListViewProjects: SERVER + "/api/user/project",
    MaterialSearch: SERVER + "/api/material/search",
    EditDataImr: SERVER + "/api/edit/IMR/request",
    ReleaseRequest: SERVER + "/api/send/request/approval",


    savedRequest: SERVER + "/api/saved",
    recentRequest: SERVER + "/api/recent",

}
